import { createContext } from 'react'

const noop = (...args) => console.log(...args)

export type EditAPIProps = {
    saveGifsToCollection: (gifs: (string | number)[], channelId: number) => void
}

const EditAPIContext = createContext({
    saveGifsToCollection: noop,
} as EditAPIProps)

export default EditAPIContext
